import React from 'react'
import './App.css'

import ProfileLogin from '../containers/ProfileLogin'

const App = () => (
  <ProfileLogin />
)

export default App



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/components/App.js